import { useEffect } from 'react'

interface IProps {
  children: React.ReactElement<any>
  enabled?: boolean
}

/**
 * Freeze scroll when enabled.
 * This implementation is an extension of the one from core module to solve specific OTO issue.
 */
const ScrollFreeze = (props: IProps): React.ReactElement<any> => {
  const { children, enabled = true } = props

  useEffect(() => {
    if (enabled) {
      // Capture scroll positions
      const previousScrollY = window.scrollY
      const previousScrollX = window.scrollX
      const previousOverflow = document.documentElement.style.overflow
      const previousBodyOverflow = document.body.style.overflow
      const previousTouchAction = document.documentElement.style.touchAction
      const previousTop = document.body.style.top

      // Freeze scroll
      document.documentElement.style.overflow = 'hidden'
      document.body.style.overflow = 'hidden'
      document.documentElement.style.touchAction = 'none'
      document.body.style.top = `-${previousScrollY}px`

      return () => {
        // Restore styles and scroll position
        document.documentElement.style.overflow = previousOverflow
        document.body.style.overflow = previousBodyOverflow
        document.documentElement.style.touchAction = previousTouchAction
        document.body.style.top = previousTop

        // Restore scroll position
        window.scrollTo(previousScrollX, previousScrollY)
      }
    }
  }, [enabled])

  return <>{children}</>
}

export default ScrollFreeze
